const basicListingsPath = (routePath = '') =>
  `listings${routePath && '/'}${routePath}`;

export const createListings = (listingId: string) =>
  basicListingsPath(`${listingId}/create-lead`);
